
export enum TranslationNotification {
	TranslationLoaded = '[TranslationNotification] TranslationLoaded',
}
